export const LOFI_PASSWORD_PAGES = [
  {
    slug: 'insmed',
    password: 'happiness',
  },
  {
    slug: 'partner-summit',
    password: 'SCFsummit23',
  },
];
